import React from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import WidgetMessage from '../../../widget/WidgetMessage';

const maxCount = 5;

const isLeafArea = (node) => !node || !Array.isArray(node.children) || node.children.length === 0;

const buildLevel = (node) => (isLeafArea(node) ? 'third' : 'second');

class AreaSelectModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      secondIndex: 0,
      codes: props.selectedCodes || [],
      items: props.selectedItems || [],
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedCodes, selectedItems, visible } = this.props;
    // 仅在弹窗从关闭变为打开时重置为父级传入的已选项；
    // 弹窗打开后父级传入新数组引用不清空用户的临时选择，关闭时也不重置。
    if (!prevProps.visible && visible) {
      this.setState({
        codes: selectedCodes || [],
        items: selectedItems || [],
        tabIndex: 0,
        secondIndex: 0,
      });
    }
  }

  getDerived() {
    const { areaList = [], allowSecondLevel = true } = this.props;
    const { tabIndex, secondIndex } = this.state;
    const activeArea = areaList[tabIndex];
    const secondList = (activeArea && activeArea.children) || [];
    const activeSecond = secondList[secondIndex];
    const thirdList = (activeSecond && activeSecond.children) || [];

    let selectable;
    if (thirdList.length > 0) {
      selectable = { list: thirdList, level: 'third' };
    } else if (allowSecondLevel && secondList.length > 0) {
      selectable = { list: secondList, level: 'second' };
    } else {
      selectable = { list: [], level: 'third' };
    }

    return { activeArea, secondList, activeSecond, thirdList, selectable };
  }

  toggleCity = (item, level) => {
    const { allowSecondLevel = true, single = true } = this.props;
    const { codes, items } = this.state;
    const { activeArea, activeSecond, secondList } = this.getDerived();

    const effectiveLevel = allowSecondLevel ? level : 'third';
    const parentProvince = activeArea ? activeArea.code : undefined;
    const parentCity = effectiveLevel === 'third' && activeSecond ? activeSecond.code : undefined;

    if (single) {
      const same = codes[0] === item.code;
      if (same) {
        this.setState({ codes: [], items: [] });
        return;
      }
      const record = { ...item, level: effectiveLevel, province: parentProvince, cityCode: parentCity };
      this.setState({ codes: [item.code], items: [record] });
      return;
    }

    if (codes.includes(item.code)) {
      this.setState({
        codes: codes.filter((code) => code !== item.code),
        items: items.filter((selected) => selected.code !== item.code),
      });
      return;
    }

    if (effectiveLevel === 'second') {
      const sameProvince = items.filter((selected) => selected.province === parentProvince);
      const others = items.filter((selected) => selected.province !== parentProvince);
      const sameCityDistricts = items.filter((selected) => selected.cityCode && secondList.some((city) => city.code === selected.cityCode));
      if (sameProvince.length > 0 || sameCityDistricts.length > 0) {
        const next = [...others, { ...item, level: effectiveLevel, province: parentProvince, cityCode: undefined }];
        if (next.length > maxCount) {
          WidgetMessage.warning('最多只可选5个地区！');
          return;
        }
        this.setState({ items: next, codes: next.map((node) => node.code) });
        return;
      }
      if (codes.length >= maxCount) {
        WidgetMessage.warning('最多只可选5个地区！');
        return;
      }
      this.setState({
        codes: [...codes, item.code],
        items: [...items, { ...item, level: effectiveLevel, province: parentProvince, cityCode: undefined }],
      });
      return;
    }

    const sameProvince = items.filter((selected) => selected.province === parentProvince);
    const sameLevel = items.filter((selected) => selected.code === item.code);
    if (sameLevel.length > 0) {
      this.setState({
        codes: codes.filter((code) => code !== item.code),
        items: items.filter((selected) => selected.code !== item.code),
      });
      return;
    }
    const sameProvinceSecond = sameProvince.filter((selected) => selected.level === 'second');
    const sameCityDistricts = sameProvince.filter((selected) => selected.cityCode === parentCity);
    const others = items.filter((selected) => selected.province !== parentProvince);
    let next;
    if (sameProvinceSecond.length > 0) {
      next = [...others, ...sameProvinceSecond.filter((s) => s.code !== parentCity).map((s) => ({ ...s })), { ...item, level: effectiveLevel, province: parentProvince, cityCode: parentCity }];
    } else {
      next = [...others, ...sameCityDistricts, { ...item, level: effectiveLevel, province: parentProvince, cityCode: parentCity }];
    }
    if (next.length > maxCount) {
      WidgetMessage.warning('最多只可选5个地区！');
      return;
    }
    this.setState({ codes: next.map((node) => node.code), items: next });
  };

  removeSelected = (item) => {
    const { single = true } = this.props;
    const { codes, items } = this.state;
    if (single) {
      this.setState({ codes: [], items: [] });
      return;
    }
    this.setState({
      codes: codes.filter((code) => code !== item.code),
      items: items.filter((selected) => selected.code !== item.code),
    });
  };

  render() {
    const {
      visible,
      areaList = [],
      onCancel,
      onConfirm,
      single = true,
    } = this.props;
    const { tabIndex, secondIndex, codes, items } = this.state;
    const { secondList, selectable } = this.getDerived();

    return (
      <Modal
        title="期望工作地选择"
        visible={visible}
        centered
        width={890}
        bodyStyle={{ maxHeight: 420, overflow: 'auto', padding: '12px 20px' }}
        wrapClassName="resume-new-selector-modal resume-new-selector-modal-compact"
        onCancel={onCancel}
        footer={<Button type="primary" onClick={() => onConfirm(single ? items.slice(0, 1) : items)}>确认</Button>}
        getContainer={false}
      >
        <div className="resume-new-selector-body is-area">
          <ul className="resume-new-selector-left">
            {areaList.map((item, index) => (
              <li
                key={item.code || index}
                className={tabIndex === index ? 'is-active' : ''}
                onClick={() => { this.setState({ tabIndex: index, secondIndex: 0 }); }}
              >
                {item.name}
              </li>
            ))}
          </ul>
          <ul className="resume-new-selector-middle">
            {secondList.map((item, index) => {
              const active = secondIndex === index || codes.includes(item.code);
              const hasChildren = !isLeafArea(item);
              return (
                <li
                  key={item.code || index}
                  className={active ? 'is-active' : ''}
                  onClick={() => {
                    if (hasChildren) {
                      this.setState({ secondIndex: index });
                      return;
                    }
                    this.toggleCity(item, 'second');
                  }}
                >
                  {item.name}
                </li>
              );
            })}
          </ul>
          <div className="resume-new-selector-right">
            {selectable.list.length === 0 ? (
              <div className="resume-new-selector-empty">
                {secondList.length === 0 ? '该省份暂无可选地区' : '请选择市级'}
              </div>
            ) : (
              selectable.list.map((item) => (
                <button
                  type="button"
                  key={item.code}
                  className={codes.includes(item.code) ? 'is-active' : ''}
                  onClick={() => this.toggleCity(item, selectable.level)}
                >
                  {item.name}
                </button>
              ))
            )}
          </div>
        </div>
        <div className="resume-new-selected">
          <div className="resume-new-selected-header">
            <span>我选择的地区</span>
            <span>已选{items.length} / {single ? 1 : maxCount}</span>
          </div>
          <div className="resume-new-selected-tags">
            {items.length === 0 ? <span className="resume-new-selected-empty">暂未选择</span> : null}
            {items.map((item) => (
              <span key={`${item.province || ''}-${item.cityCode || ''}-${item.code}`}>
                {item.name}
                <CloseOutlined onClick={() => this.removeSelected(item)} />
              </span>
            ))}
          </div>
        </div>
      </Modal>
    );
  }
}

export default AreaSelectModal;
